import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "facebook",
  "use": "facebook-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"facebook\"><path fill-rule=\"evenodd\" d=\"M1 1.993C1 1.445 1.445 1 1.993 1h16.014c.548 0 .993.445.993.993v16.014a.994.994 0 0 1-.993.993H1.993A.994.994 0 0 1 1 18.007V1.993ZM10.686 19v-7.005h-2.5V9.497h2.5V7.192c0-2.326 1.373-3.696 3.448-3.696.994 0 1.804.106 2.053.14v2.611h-1.67c-1.127 0-1.338.56-1.338 1.346v1.904h2.89l-.408 2.498h-2.482V19h-2.493Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol